import {
  CatalogQueryType,
  CatalogSearchResultData,
  CatalogSearchResultItem,
  ResourceCatalogApplication,
  ResourceCatalogApplicationPaged,
} from './types';

import { DevHubGrid } from '@devxdiscover/devhub-ui';

/**
 * ApplicationResult returns application details for the search results
 * @param data a row containing data for the application
 */
export const ApplicationDetails = (data: CatalogSearchResultItem) => {
  const applicationData = data.item as ResourceCatalogApplication;
  return (
    <DevHubGrid container>
      <DevHubGrid item xs={1} />
      <DevHubGrid container item xs={11} spacing={1}>
        {applicationData.description && (
          <>
            <DevHubGrid item xs={2}>
              <span style={{ fontWeight: 'bold' }}>Description</span>
            </DevHubGrid>
            <DevHubGrid item xs={10}>
              {applicationData.description}
            </DevHubGrid>
            <DevHubGrid item xs={2}>
              <span style={{ fontWeight: 'bold' }}>ID</span>
            </DevHubGrid>
            <DevHubGrid item xs={10}>
              {applicationData.applicationId}
            </DevHubGrid>
          </>
        )}
      </DevHubGrid>
    </DevHubGrid>
  );
};

/**
 * convertApplicationSearchResult converts the application search results into a format that can be displayed
 * @param applicationData the data returned from the fusion query
 */
export const convertApplicationSearchResult = (
  applicationData: ResourceCatalogApplicationPaged,
): CatalogSearchResultData => {
  const applicationItems: CatalogSearchResultItem[] = (
    applicationData.resources.applicationsPaged
      .applications as ResourceCatalogApplication[]
  ).map(item => ({
    expandable: true,
    name: item.name,
    id: item.applicationId,
    status: item.status,
    owner: item.owner?.displayName,
    type: CatalogQueryType.Application,
    item: item,
  }));

  return {
    items: applicationItems,
    totalCount: applicationData.resources.applicationsPaged.totalCount,
  };
};
